import React, { PureComponent } from 'react';
import classNames from 'classnames';
import styles from './style.scss';

export default class GridTitleAndCount extends PureComponent {
    
    handleClick = _ => {

        this.props.handleClick ? this.props.handleClick(this.props.title) : '';
    }

    render() {

        return (
            <div
                className={classNames(styles.titleAndCounter)}
                onClick={this.handleClick}
            >
                <div
                    className={classNames(styles.itemTitle)}
                >
                    {this.props.title}
                </div>
                <div
                    className={classNames(styles.itemCounter)} data-tip data-event='click' data-for={this.props.dataFor}
                >
                    {this.props.count}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/gridTitleAndCount/index.jsx